import { useQuery } from '@tanstack/react-query';
import { getMatchQuestions } from '../api/match-api';
import { matchKeys } from '../queryKeys';

/** Bundled quiz copy changes rarely; reuse while species unchanged. */
const STALE_MS = 5 * 60 * 1000;
const GC_MS = 30 * 60 * 1000;

export type UseMatchQuestionsQueryOptions = {
  /** When false, skips fetch (e.g. species gate before quiz phase). */
  enabled?: boolean;
};

export function useMatchQuestionsQuery(
  species: 'Cat' | 'Dog',
  options?: UseMatchQuestionsQueryOptions,
) {
  const enabled = options?.enabled ?? true;

  return useQuery({
    queryKey: matchKeys.questions(species),
    queryFn: () => getMatchQuestions(species),
    staleTime: STALE_MS,
    gcTime: GC_MS,
    enabled,
  });
}
